import { Injectable } from '@angular/core';
import { ERoutesApi } from '@core/enums';
import { GenericCrudService } from '@core/services';
import { _Foto } from '../model/foto.model copy';

@Injectable({ providedIn: 'root' })
export class FotoService extends GenericCrudService<_Foto, _Foto> {
  constructor() {
    super(ERoutesApi.FOTO);
  }

  getUrisFromPt(codigoFormulario: string) {
    return this.httpService.get(`${ERoutesApi.FOTO}/listar_urls?codigoFormulario=${codigoFormulario}&tipoFormulario=PT`);
  }

  getFotoBlob(uriFoto: string) {
    return this.httpService.getFile(`${ERoutesApi.FOTO}/imagem?uri=${uriFoto}`);
  }

  downloadTodasFotos(codigoFormulario: string): void {
    this.httpService.getFile(`${ERoutesApi.FOTO}/download-todas?codigoFormulario=${codigoFormulario}&tipoFormulario=PT`)
      .subscribe({
        next: (response: any) => {
          const url = URL.createObjectURL(response.body);
          const a = document.createElement('a');
          a.href = url;
          a.download = `evidencias_${codigoFormulario}.zip`;
          a.click();
          URL.revokeObjectURL(url);
        }
      });
  }
}
